var exports = {
  "AS": "x805b157e--cca643--item",
  "AD": "x805b157e--cca643--icon-block",
  "Yu": "x805b157e--cca643--text-block",
  "Pf": "x805b157e--cca643--label",
};

module.exports = exports;
